import request from './request'
import baseUrl from './baseUrl';
const DEBUG_MODE = false
const URL_PREFIX = DEBUG_MODE ? '' : baseUrl;

export function login (data) {
  return request.post(`${URL_PREFIX}/api/AdminUsers/login`, data)
}

export function getToken (id,token) {
    return request.get(`${URL_PREFIX}/api/AdminUsers/${id}/getUploadToken?access_token=${token}`)
}



// WEBPACK FOOTER //
// ./src/api/login.js